import { useLayout } from "@/contexts/UseLayout";

export function getNameStatusDeskById(listStatus: any, statusDek_id: any) {
  if (listStatus) {
    const statusName = listStatus.data?.find(
      (status: any) => status.id === statusDek_id
    );
    return statusName ? statusName.name : "Status não encontrado";
  }
}

export function getNameProdutoById(produto_id: any) {
  const useDadosContext = useLayout();
  const getAllProdutos = useDadosContext.getConfig.typesDesks;

  if (getAllProdutos) {
    const produtoName = getAllProdutos?.find(
      (client: any) => client.id === produto_id
    );
    return produtoName ? produtoName.name : "Produto não Cadastrato";
  }
}

export function getNameClientById(listClients: any, client_id: any) {
  if (listClients && Array.isArray(listClients?.data)) {
    const clientName = listClients?.data.find(
      (client: any) => client.id === client_id
    );
    return clientName?.name_fantasy
      ? clientName?.name_fantasy
      : "Cliente não Cadastrato";
  }
}

export function getNomeDaAgenciaPorId(listAgencys: any, agency_id: any) {
  if (listAgencys && Array.isArray(listAgencys)) {
    const agencyUser = listAgencys?.find(
      (agency: any) => agency.id === agency_id
    );
    return agencyUser?.name_fantasy ?? agencyUser?.nome ?? "-";
  }
}

export function getNomePorId(list: any, id: any) {
  const agencyUser = list?.find((agency: any) => agency.id === id);
  return agencyUser ? agencyUser.nome : "Cargo não encontrado";
}

export function getNomeStatusPorId(list: any, id: any) {
  if (list && Array.isArray(list)) {
    const status = list?.find((status: any) => status.id == id);
    return status ? status.name : "Status não encontrado";
  }
}
